import { ActionBase } from '../../../core/store/action/ActionBase';

export const CREATE_CODESYSTEMVERSION_DRAFT = '[Vocabulary] Create CodeSystemVersion Draft';

export class CreateCodeSystemVersionDraftAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = CREATE_CODESYSTEMVERSION_DRAFT;

  constructor(public payload: { key: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/vocabulary/store/actions/CreateCodeSystemVersionDraftAction.ts